import { useCallback } from 'react';

import { useConfig } from '@occc/config';
import { OfferFragment } from '@occc/graphql';
import {
  OfferSubtype,
  OfferType,
  PartialOfferFragment,
} from '@occc-app/offerValidationService/types';
import { getOfferComponentSubType, getOfferComponentType } from '@occc-app/offerHelpers/utils';

const getPromotionSubType = (offer: OfferFragment | PartialOfferFragment) => {
  if (getOfferComponentType(offer) !== OfferType.Promotion) {
    return null;
  }
  return getOfferComponentSubType(offer);
};

const getIsOrderAheadEnabled = (
  offer: OfferFragment | PartialOfferFragment | undefined,
  orderAheadConfig: { enabled: boolean; shouldShowDisplayForOrderAheadToggle: boolean },
) => {
  if (!offer) {
    return false;
  }

  const promotionSubType = getPromotionSubType(offer);

  return (
    orderAheadConfig.enabled &&
    orderAheadConfig.shouldShowDisplayForOrderAheadToggle &&
    !!promotionSubType &&
    [
      OfferSubtype.ProductDiscount,
      OfferSubtype.TransactionDiscount,
      OfferSubtype.VarietyDiscount,
      OfferSubtype.BOGO,
    ].includes(promotionSubType)
  );
};

export const useGetIsOrderAheadEnabledForPromotion = () => {
  const orderAheadConfig = useConfig('orderAheadConfig');

  return useCallback(
    (offer: OfferFragment | PartialOfferFragment | undefined) => {
      return getIsOrderAheadEnabled(offer, orderAheadConfig);
    },
    [orderAheadConfig],
  );
};
